import { render, staticRenderFns } from "./setPopup.vue?vue&type=template&id=e42304ca&"
import script from "./setPopup.vue?vue&type=script&lang=js&"
export * from "./setPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports